import * as React from 'react';

const SendInviteGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h144v144H0z" />
            <path
                fill="#F6682F"
                fillRule="nonzero"
                d="M49.714 92.693h68.529V48H49.714z"
            />
            <path
                fill="#F8FAFF"
                fillRule="nonzero"
                d="M118.243 48L83.979 79.284 49.714 48z"
            />
            <path
                stroke="#363A43"
                strokeWidth={3}
                d="M49.714 92.693h68.529V48H49.714z"
            />
            <path
                stroke="#363A43"
                strokeWidth={3}
                d="M118.243 48L83.979 79.284 49.714 48m0 45.08l19.367-19.366m49.714 19.367L99.429 73.714"
            />
            <path
                stroke="#363A43"
                strokeWidth={2}
                d="M25.714 56.571h2.98m2.163 0h2.98m3.877 0h2.98m-9.837 13.715h2.98m3.877 0h2.98m2.163 0h2.98M25.714 85.714h2.98m2.163 0h2.98m3.877 0h2.98"
            />
        </g>
    </svg>
);

SendInviteGraphicSvg.displayName = 'SendInviteGraphicSvg';
export default SendInviteGraphicSvg;
